import { Typography } from '@mui/material';

import { Link, useNavigate } from 'react-router-dom';

import Breadcrumbs from 'common/components/Breadcrumbs/Breadcrumbs';
import { appPages } from 'common/constants/TextContent';
import { toSentenceCase, urlWithTenant } from 'common/utils/utilFunctions';

import styles from './RegulationBreadcrumbs.module.scss';

export interface ICustomBreadcrumbsProps {
	title: string;
	type: string;
	path?: string;
	key: string;
	dataTestId?: string;
}

interface IBreadCrumb {
	items: ICustomBreadcrumbsProps[];
	storageWrapper: any;
}

const { HOME_PAGE } = appPages;

const RegulationBreadcrumbs = (props: IBreadCrumb) => {
	const { items, storageWrapper } = props;

	const navigate = useNavigate();

	const breadcrumbs: any = [];

	let skipNext = false;

	const updatedItems: ICustomBreadcrumbsProps[] = [];

	items.forEach((item: any) => {
		if (skipNext) {
			skipNext = false;
			return;
		}

		if (item.title === HOME_PAGE) {
			skipNext = true;
		}
		updatedItems.push(item);
	});

	updatedItems.forEach((updatedItem) => {
		const { type, key, path, dataTestId } = updatedItem;

		let { title } = updatedItem;

		if (type === 'link') {
			const item = storageWrapper.getStorageItem('selectedCardDetails');
			if (key === 'req-inv-selected-tab' && item) {
				title = toSentenceCase(item.selectedCardName || '');
			}
			if (title !== '') {
				breadcrumbs.push(
					<Link
						key={key}
						to={urlWithTenant(`/${path}`)}
						onClick={() => updatedItem.title === HOME_PAGE && navigate(-1)}
						data-testid={dataTestId}
					>
						{title}
					</Link>,
				);
			}
		} else if (type === 'text') {
			breadcrumbs.push(<Typography key={key}>{title}</Typography>);
		}
	});

	return (
		<Breadcrumbs
			breadcrumbs={breadcrumbs}
			className={styles['bread-crumbs']}
			customClass
		/>
	);
};

export default RegulationBreadcrumbs;
